import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { PdfChart } from '../../shared/pdfChart';
import { ExportExcelService } from 'app/service/export-excel.service';
import { ExportPPTService } from 'app/service/export-ppt.service';
import { CpmService } from '../../service/cpm.service';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-global-index-member',
  templateUrl: './global-index-member.component.html',
  styleUrls: ['./global-index-member.component.scss']
})
export class GlobalIndexMemberComponent implements OnInit, OnDestroy, AfterViewInit {
  radioItems;
  radioValue;
  form: FormGroup;
  msciData;
  getPrint;
  djsiData;
  dataChart;
  chartGlobalIndexMember;
  pdfChart: PdfChart = new PdfChart();
  dataProvider;
  potentialList = [];
  msciList = [];
  djsiList = [];
  textMark = 'MSCI Thailand (standard)';
  dateThisRound;
  datePrevRound;
  noOfSecThisRound;
  noOfSecPrevRound;
  noOfComThisRound;
  noOfComPrevRound;
  weightThisRound;
  weightPrevRound;

  constructor(
    private router: Router,
    private amChart: AmChartsService,
    private activatedRoute: ActivatedRoute,
    private excelService: ExportExcelService,
    private pptService: ExportPPTService,
    private cpmService: CpmService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    const { radioValue } = this.activatedRoute.snapshot.params;
    const { pdf, print } = this.activatedRoute.snapshot.data;
    this.getPrint = print;
    this.pdfChart.setPdf(pdf);
    radioValue === undefined
      ? (this.radioValue = 'MSCI')
      : (this.radioValue = radioValue.toUpperCase());
    this.radioItems = [
      { value: 'MSCI', des: 'MSCI Thailand (standard)' },
      { value: 'DJSI', des: 'Dow Jones sustainability indices (DJSI)' },
      {
        value: 'LISTED',
        des:
          'Listed companies which market cap. >= $1 bil.USD and daily avg trading value (past 6 months) >= $10 mil.USD'
      }
    ];
    this.form = new FormGroup({
      radioValue: new FormControl(this.radioValue)
    });
    if (radioValue !== undefined) {
      this.loadData();
    }

  }

  async loadData() {
    await this.cpmService.getGlobalIndexMember('Potential', new Date(), 5).then(obj => {
      obj.map(data => {
        this.potentialList.push(data);
      });
    });
    await this.cpmService.getGlobalIndexMember('MSCI', new Date(), 5).then(obj => {
      obj.map(data => {
        this.msciList.push(data);
      });
    });
    await this.cpmService.getGlobalIndexMember('DJSI', new Date(), 5).then(obj => {
      obj.map(data => {
        this.djsiList.push(data);
      });
    });
    this.mapDataList(this.msciList, 'MSCI');

    if (this.radioValue === 'MSCI') {
      this.textMark = 'MSCI Thailand (standard)'
    } else if (this.radioValue === 'DJSI') {
      this.textMark = 'Dow Jones sustainability indices (DJSI)'
    } else {
      this.textMark = 'Listed companies which market cap. >= $1 bil.USD' + '\n' + 'and daily avg trading value (past 6 months) >= $10 mil.USD'
    }

    this.dataChart = this.genChartData(this.radioValue);
    this.chartGlobalIndexMember = this.amChart.makeChart(
      'globalMarketChartdiv',
      this.dataChart
    );
    if (document.getElementById('globalMarketChartdiv')) {
      document
        .getElementById('globalMarketChartdiv')
        .classList.add('chartFinished');
    }
    this.onChangeData()
  }

  onChangeData() {
    this.radioValue = this.form.get('radioValue').value;
    if (this.radioValue === 'MSCI') {
      this.textMark = 'MSCI Thailand (standard)'
      this.mapDataList(this.msciList, 'MSCI');
    } else if (this.radioValue === 'DJSI') {
      this.textMark = 'Dow Jones sustainability indices (DJSI)'
      this.mapDataList(this.djsiList, 'DJSI');
    } else {
      this.textMark = 'Listed companies which market cap. >= $1 bil.USD' + '\n' + 'and daily avg trading value (past 6 months) >= $10 mil.USD'
      this.mapDataList(this.potentialList, 'Potential');
    }

    // this.amChart.updateChart(this.chartGlobalIndexMember, () => {
    //   this.chartGlobalIndexMember.dataProvider = this.dataProvider;
    // });

    this.dataChart = this.genChartData(this.radioValue);
    this.chartGlobalIndexMember = this.amChart.makeChart(
      'globalMarketChartdiv',
      this.dataChart
    );
  }

  mapDataList(dataList, type) {
    this.dataProvider = [];
    if (type === 'MSCI') {
      this.msciData = [];
      for (let i = 0; i < dataList.length; i++) {
        this.dataProvider.push({
          date: this.datePipe.transform(dataList[i].asOfDate, 'd MMM yyyy'),
          noOfCompany: dataList[i].noOfCompanies,
          noOfSecurities: dataList[i].noOfSecurities,
          totalWeight: dataList[i].totalWeight
        });
        if (i === dataList.length - 2) {
          const previousRound = dataList[i].securities;
          const presentRound = dataList[i + 1].securities;
          if (previousRound.length > presentRound.length) {
            for (let j = 0; j < previousRound.length; j++) {
              if (j > presentRound.length - 1) {
                this.msciData.push({
                  tickerThisYear: null,
                  sectorThisYear: null,
                  weightThisYear: null,
                  tickerLastYear: previousRound[j].symbol,
                  sectorLastYear: previousRound[j].sector,
                  weightLastYear: previousRound[j].weight
                });
              } else {
                this.msciData.push({
                  tickerThisYear: presentRound[j].symbol,
                  sectorThisYear: presentRound[j].sector,
                  weightThisYear: presentRound[j].weight,
                  tickerLastYear: previousRound[j].symbol,
                  sectorLastYear: previousRound[j].sector,
                  weightLastYear: previousRound[j].weight
                });
              }
            }
          } else if (previousRound.length === presentRound.length) {
            for (let j = 0; j < presentRound.length; j++) {
              this.msciData.push({
                tickerThisYear: presentRound[j].symbol,
                sectorThisYear: presentRound[j].sector,
                weightThisYear: presentRound[j].weight,
                tickerLastYear: previousRound[j].symbol,
                sectorLastYear: previousRound[j].sector,
                weightLastYear: previousRound[j].weight
              });
            }
          } else {
            for (let j = 0; j < presentRound.length; j++) {
              if (j > previousRound.length - 1) {
                this.msciData.push({
                  tickerThisYear: presentRound[j].symbol,
                  sectorThisYear: presentRound[j].sector,
                  weightThisYear: presentRound[j].weight,
                  tickerLastYear: null,
                  sectorLastYear: null,
                  weightLastYear: null
                });
              } else {
                this.msciData.push({
                  tickerThisYear: presentRound[j].symbol,
                  sectorThisYear: presentRound[j].sector,
                  weightThisYear: presentRound[j].weight,
                  tickerLastYear: previousRound[j].symbol,
                  sectorLastYear: previousRound[j].sector,
                  weightLastYear: previousRound[j].weight
                });
              }
            }
          }
        }
      }
      this.weightThisRound = this.dataProvider[4].totalWeight;
      this.weightPrevRound = this.dataProvider[3].totalWeight;
    } else {
      this.djsiData = [];
      for (let i = 0; i < dataList.length; i++) {
        this.dataProvider.push({
          date: this.datePipe.transform(dataList[i].asOfDate, 'd MMM yyyy'),
          noOfCompany: dataList[i].noOfCompanies,
          noOfSecurities: dataList[i].noOfSecurities
        });
        if (i === dataList.length - 2) {
          const previousRound = dataList[i].securities;
          const presentRound = dataList[i + 1].securities;
          if (previousRound.length > presentRound.length) {
            for (let j = 0; j < previousRound.length; j++) {
              if (j > presentRound.length - 1) {
                this.djsiData.push({
                  tickerThisYear: null,
                  sectorThisYear: null,
                  tickerLastYear: previousRound[j].symbol,
                  sectorLastYear: previousRound[j].sector
                });
              } else {
                this.djsiData.push({
                  tickerThisYear: presentRound[j].symbol,
                  sectorThisYear: presentRound[j].sector,
                  tickerLastYear: previousRound[j].symbol,
                  sectorLastYear: previousRound[j].sector
                });
              }
            }
          } else if (previousRound.length === presentRound.length) {
            for (let j = 0; j < presentRound.length; j++) {
              this.djsiData.push({
                tickerThisYear: presentRound[j].symbol,
                sectorThisYear: presentRound[j].sector,
                tickerLastYear: previousRound[j].symbol,
                sectorLastYear: previousRound[j].sector
              });
            }
          } else {
            for (let j = 0; j < presentRound.length; j++) {
              if (j > previousRound.length - 1) {
                this.djsiData.push({
                  tickerThisYear: presentRound[j].symbol,
                  sectorThisYear: presentRound[j].sector,
                  tickerLastYear: null,
                  sectorLastYear: null
                });
              } else {
                this.djsiData.push({
                  tickerThisYear: presentRound[j].symbol,
                  sectorThisYear: presentRound[j].sector,
                  tickerLastYear: previousRound[j].symbol,
                  sectorLastYear: previousRound[j].sector
                });
              }
            }
          }
        }
      }
    }
    this.dateThisRound = this.dataProvider[4].date;
    this.datePrevRound = this.dataProvider[3].date;
    this.noOfSecThisRound = this.dataProvider[4].noOfSecurities;
    this.noOfSecPrevRound = this.dataProvider[3].noOfSecurities;
    this.noOfComThisRound = this.dataProvider[4].noOfCompany;
    this.noOfComPrevRound = this.dataProvider[3].noOfCompany;
  }

  genChartData(radioValue) {
    const dataChart = {
      type: 'serial',
      theme: 'none',
      color: 'black',
      fontFamily: 'browallia',
      fontSize: 18,
      dataProvider: this.dataProvider,
      valueAxes: [
        {
          id: 'ValueAxis-1',
          stackType: 'regular',
          title: 'Number of companies'
        },
        {
          id: 'ValueAxis-2',
          position: 'right',
          title: 'Date'
        }
      ],
      graphs: [
        {
          balloonText: ' <b>[[title]][[category]] #Comp[[value]]</b>',
          fillAlphas: 0.8,
          labelText: '[[value]]',
          labelPosition: 'top',
          lineAlpha: 0.3,
          title: 'Period : ',
          type: 'column',
          color: '#000',
          fillColors: '#ffa400',
          valueField: 'noOfCompany',
          columnWidth: 0.5
        }
      ],
      categoryField: 'date',
      categoryAxis: {
        gridPosition: 'start',
        title: 'Date'
      },
      titles: [
        {
          id: 'Title-1',
          size: 18,
          text: this.textMark
        }
      ]
    };

    return dataChart;
  }


  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 4000);
    }
  }

  excel() {
    if (this.radioValue === 'MSCI') {
      this.excelService.exportGlobalIndexMemberMSCI(
        this.msciData,
        'Number of companies of global standard indices and measurement',
        this.dataProvider
      );
    } else {
      this.excelService.exportGlobalIndexMemberDJSI(
        this.djsiData,
        'Number of companies of global standard indices and measurement',
        this.dataProvider
      );
    }
  }

  ngOnDestroy() {
    if (
      this.chartGlobalIndexMember &&
      this.chartGlobalIndexMember.legend &&
      this.chartGlobalIndexMember.legend.destroy
    ) {
      const tmp =
        this.chartGlobalIndexMember != null
          ? this.amChart.destroyChart(this.chartGlobalIndexMember)
          : null;
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/global-index-member/global-index-member.component.ts